import CRUD from "@/firebase/crud";
import store from "@/store/index";
//import filter from "lodash-es/filter";
//import find from "lodash-es/find";

const clip = {
  namespaced: true,
  state: {
    clipCurrentTime: "00:00",
    clipEntireDuration: "00:00",
    clipSpeed: "0",
    active: {
      sponsorID: "",
      clipStart: "00:00",
      clipEnd: "00:00",
      clipDuration: "00:00",
      status: "Draft",
      sponsor: "Admiral",
      type: "Motion",
      location: "Shirt",
      clarity: "Good",
      clarityNumber: "1",
      comments: "",
      gameID: "",
      portalID: null
    },
    panelID: "1",
    panelName: "Clients",
    sponsorIcon: "icons8-image",
    typeIcon: "icons8-running",
    locationIcon: "icons8-jersey",
    clarityIcon: "icons8-like-button",
    clipResult: {},
    Clips: [],
    result: {},
    ClipByID: [],
    sponByGameResult: [],
    secondSponByGameResult: [],
    previousKey: "none",
  },
  mutations: {
    setPreviousKey(state, data) {
      state.previousKey = data;
    },
    setActive(state, data) {
      // Used to update the active Value
      state.analysis = data;
    },
    setActiveValue(state, [name, data]) {
      // Used to update the active Value
      state.active[name] = data;
    },
    setClipByID(state, data) {
      state.ClipByID = data;
    },
    setSponByGameResultEmpty(state){
      state.sponByGameResult = null;
    },
    setSponByGameResult(state, data) {
      state.sponByGameResult = data;
    },
    setSecondSponByGameResult(state, data) {
      state.secondSponByGameResult = data;
    },
    setValue(state, [name, data]) {
      state[name] = data;
    },
    setClipResult(state, data) {
      // console.log("clipResult = " + JSON.stringify(data, null, 2));
      state.clipResult = data;
    },
    setClips(state, data) {
      state.Clips = data;
    },
    setClipSendData(state, data) {
      state.result = data;
    }
  },
  getters: {
    startMoment: state => state.active.clipStart
  },
  actions: {
    createClip: async ({ commit }, payload) => {
      try {
        let Collection = "clips";
        let Data = payload[1];
        let portalID = payload[2];
        let Result = Promise.resolve(CRUD.CreateDocument(Collection, Data));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("clip/setClipResult", Response.message);
              store.dispatch("clip/readClips", [
                "clips",
                portalID,
                "clip/setClips"
              ]);
              break;
            case "failure":
              store.commit("clip/setClipResult", Response.message);
              break;
            case "error":
              store.commit("clip/setClipResult", Response.message);
              break;
            default:
              store.commit("clip/setClipResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    readClips: async ({ commit }, payload) => {
      // console.log("READING CLIPS with PAYLOAD " + JSON.stringify(payload));
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let Mutation = payload[2];
        store.commit(Mutation, []);
        let Result = Promise.resolve(
          CRUD.ReadDocuments(Collection, portalID, null)
        );
        Result.then(Response => {
          // // console.log("MY RESPONSE IS " + JSON.stringify(Response, null, 2))
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              break;
            case "error":
              break;
            default:
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    readClipByID: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Mutation = payload[2];
        let Result = Promise.resolve(CRUD.GetDocumentByID(Collection, ID));
       // // console.log("PAAAAYLOAD = " + JSON.stringify(payload, null, 2));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              // // console.log("SUCCESSSSSSSSSSSSSSSSSSS")
              // // console.log(Response)
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setDocResultByID", Response.message);
              break;
            case "error":
              store.commit("Admin/setDocResultByID", Response.message);
              break;
            default:
              store.commit("Admin/setDocResultByID", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // store.commit("Admin/setDocumentResult", "Error");
        // console.log(err);
      }
    },
    updateClips: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let value = payload[2];
        let Mutation = payload[3];
        let Result = Promise.resolve(CRUD.UpdateDocumentsFields(Collection, ID, value));
        // console.log("Payload update fields = " + JSON.stringify(payload, null, 2));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              store.commit("Admin/setClipResult", Response.message);
              break;
            case "error":
              store.commit("Admin/setClipResult", Response.message);
              break;
            default:
              store.commit("Admin/setClipResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    getSponsorClipsByGame: async ({ commit }, payload) => {
      // // console.log("GetSponsorClipByGame:  " + JSON.stringify(payload));
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let sponsorID = payload[2];
        let gameID = payload[3];
        let Mutation = payload[4];
        store.commit(Mutation, []);
        let Result = Promise.resolve(
          CRUD.GetSponsorClipsByGameID(
            Collection,
            portalID,
            sponsorID,
            gameID,
            null
          )
        );
        Result.then(Response => {
          //console.log("MY RESPONSE IS " + JSON.stringify(Response, null, 2))
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              break;
            case "error":
              break;
            default:
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    getClipsByGame: async ({ commit }, payload) => {
      //console.log("GetClipByGame:  " + JSON.stringify(payload));
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let gameID = payload[2];
        let Mutation = payload[3];
        store.commit(Mutation, []);
        let Result = Promise.resolve(
          CRUD.GetClipsByGameID(
            Collection,
            portalID,
            gameID,
            null
          )
        );
        Result.then(Response => {
          // // console.log("MY RESPONSE IS " + JSON.stringify(Response, null, 2))
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              break;
            case "error":
              break;
            default:
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    getClipsByStatusAndGame: async ({ commit }, payload) => {
      //console.log("GetClipByGame:  " + JSON.stringify(payload));
      try {
        let Collection = payload[0];
        let portalID = payload[1];
        let gameID = payload[2];
        let status = payload[3];
        let Mutation = payload[4];
        store.commit(Mutation, []);
        let Result = Promise.resolve(
          CRUD.GetClipsByStatusAndGameID(
            Collection,
            portalID,
            gameID,
            status,
            null
          )
        );
        Result.then(Response => {
          // // console.log("Response.result = " + JSON.stringify(Response.result, null,2 ))
          // // console.log("Response.data = " + JSON.stringify(Response, null,2 ))
          switch (Response.result) {
            case "success":
              store.commit(Mutation, Response.data);
              break;
            case "failure":
              break;
            case "error":
              break;
            default:
              break;
          }
        });
      } catch (err) {
        // console.log("ERRRRRRROR");
        // console.log(err);
      }
    },
    deleteClip: async ({ commit }, payload) => {
      try {
        let Collection = payload[0];
        let ID = payload[1];
        let Result = Promise.resolve(CRUD.DeleteDocument(Collection, ID));
        Result.then(Response => {
          switch (Response.result) {
            case "success":
              store.commit("clip/setClipResult", Response.message);
              break;
            case "failure":
              store.commit("clip/setClipResult", Response.message);
              break;
            case "error":
              store.commit("clip/setClipResult", Response.message);
              break;
            default:
              store.commit("clip/setClipResult", Response.message);
              break;
          }
        });
      } catch (err) {
        // console.log(err);
      }
    },
    sendClipData: async ({ commit }, payload) => {
      try {
        let name = payload[0];
        let sponsorID = payload[1];
        let icon = payload[2];
        let id = payload[3];
        let number = payload[4];
        // console.log(
        //   "Payload clip: " +
        //     name +
        //     ", " +
        //     sponsorID +
        //     ", " +
        //     icon +
        //     ", " +
        //     id +
        //     ", " +
        //     number
        // );
        store.commit("clip/setClipSendData", [
          name,
          sponsorID,
          icon,
          id,
          number
        ]);
      } catch (err) {
        // console.log(err);
      }
    }
  }
};

export default clip;
